import aqilaApi from './aqila-api';

export type Usage = [string, number];

class Usages {
  private readonly endpoint = 'v1/usages';

  async all(params?: { usuario?: number }) {
    const { data } = await aqilaApi.get<Usage[]>(this.endpoint, { params });
    return data;
  }
}

export default new Usages();
